export { autocapturePlugin as plugin, autocapturePlugin, DEFAULT_CSS_SELECTOR_ALLOWLIST, DEFAULT_DATA_ATTRIBUTE_PREFIX, } from './autocapture-plugin';
export { WindowMessenger } from './libs/messenger';
//# sourceMappingURL=index.js.map